import { render, staticRenderFns } from "./WhatsAppRedirect.vue?vue&type=template&id=a348d358"
import script from "./WhatsAppRedirect.vue?vue&type=script&lang=js"
export * from "./WhatsAppRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports